<template>
  <div>
    <div v-if="show" class="overlay"></div>
    <div v-if="show" class="popup-container">
      <h3 class="title">{{ getTranslatedText(title)  }}</h3>
      <p class="message">{{ getTranslatedText(message) }}</p>
      <ButtonCommon text="OK" class="button__primary" @action="handleClose" />
    </div>
  </div>
</template>

<script>
import ButtonCommon from "@/components/common/button";
import languageMixins from "@/mixins/language-mixins";

export default {
  mixins: [languageMixins],
  components: { ButtonCommon },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.popup-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  z-index: 1100;
  width: 90%;
  max-width: 400px;
  text-align: center;
}

.title {
  font-size: 1.5em;
  color: #0e0e0e;
  margin-bottom: 15px;
}

.message {
  font-size: 1em;
  color: #0e0e0e;
  margin-bottom: 20px;
}

.button__primary {
  width: 100%;
}
</style>
